import { Icon } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
  margin: 54px 0 0;

  @media (min-width: 1024px) {
    display: none;
  }
`;

const ContentArea = styled.div`
  height: 216px;
  background-color: ${theme.SECONDARY};
  display: flex;
  position: relative;

  h3  {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 14px;
  }

  p {
    font-size: 24px;
    color: #fff;
    width: 137px;
    line-height: 30px;
  }
`;

const CalculatorText = styled.div`
  padding: 16px 13px;
`;

const ImageContainer = styled.div`
  position: absolute;
  right: 22px;
  top: -4px;

  img {
    width: 193px;
  }
`;

const IconContainer = styled.div`
  margin: 15px 0 0 13px;
`;

const Calculator = (props) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ContentArea>
        <CalculatorText>
          <h3>{t('website.calculator')}</h3>

          <p>{t('website.seeHowMuch')}</p>
        </CalculatorText>

        <ImageContainer>
          <img src={require('assets/images/calculator.png')} alt="" />
        </ImageContainer>
      </ContentArea>

      <IconContainer>
        <Icon type="arrowRightLonger" col={theme.SECONDARY} dimensions={42} />
      </IconContainer>
    </Container>
  );
};

export default Calculator;
